module.exports = __webpack_public_path__ + "media/images/geckolyst-92c3acb4de36fe7acf3b6170b949bd77.png";